/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  AssociateCashDrawerBodyBody,
  CTCustomErrorResponse,
  FailureResponseResponse,
  ForbiddenResponse,
  GetAssociationResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Associate a Cash Drawer and Counter
 * @summary (From Counter) Associate a Cash Drawer and Counter
 */
export const associateCashDrawerCounter = (
  associateCashDrawerBodyBody: AssociateCashDrawerBodyBody,
) => {
  return customInstance<GetAssociationResponseResponse>({
    url: `/bm-accounting-location/v1/association`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: associateCashDrawerBodyBody,
  });
};

export const getAssociateCashDrawerCounterMutationOptions = <
  TError = ErrorType<
    CTCustomErrorResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof associateCashDrawerCounter>>,
    TError,
    { data: AssociateCashDrawerBodyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof associateCashDrawerCounter>>,
  TError,
  { data: AssociateCashDrawerBodyBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof associateCashDrawerCounter>>,
    { data: AssociateCashDrawerBodyBody }
  > = (props) => {
    const { data } = props ?? {};

    return associateCashDrawerCounter(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssociateCashDrawerCounterMutationResult = NonNullable<
  Awaited<ReturnType<typeof associateCashDrawerCounter>>
>;
export type AssociateCashDrawerCounterMutationBody = AssociateCashDrawerBodyBody;
export type AssociateCashDrawerCounterMutationError = ErrorType<
  CTCustomErrorResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
>;

/**
 * @summary (From Counter) Associate a Cash Drawer and Counter
 */
export const useAssociateCashDrawerCounter = <
  TError = ErrorType<
    CTCustomErrorResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof associateCashDrawerCounter>>,
    TError,
    { data: AssociateCashDrawerBodyBody },
    TContext
  >;
}) => {
  const mutationOptions = getAssociateCashDrawerCounterMutationOptions(options);

  return useMutation(mutationOptions);
};
